import SvgBubble from "../constants/SvgBubble";
import t from "../locales/translation";
import { PackageBestSellingProps } from "../models/PropsInterface";

const PackageBestSelling = (props: PackageBestSellingProps) => {
  /*-----------------------------
   *    FLOATING "TOP SELLING"
   *       CONTAINER STYLE
   * ----------------------------*/
  const styling = {
    backgroundImage: `url(data:image/svg+xml;base64,${btoa(SvgBubble)})`,
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    width: "90px",
    height: "50px",
  };

  return (
    <div className={`vas-row  package_type__centered_text vas-pb-0 parent`}>
      {Object.keys(props.packages).length > 1
        ? Object.keys(props.packages).map((key, index) => {
            if (key !== "Turbo" && key !== "shop")
              return <div className={`vas-col package_type__col`}></div>;
            return (
              <div className={`vas-col package_type__col`}>
                <div
                  className={`package_type__centered_text  package_type__row vas-row package_type__animate_float`}
                  style={styling}
                >
                  <p className={`vas package_type__white_text`}>
                    {" "}
                    {t.topSelling}
                  </p>
                </div>
              </div>
            );
          })
        : Object.keys(props.packages).map((key, index) => {
            return props.packages[key].map((pkg) => {
              if (!pkg.isBestOffer)
                return <div className={`vas-col package_type__col`}></div>;
              return (
                <div className={`vas-col package_type__col `}>
                  <div
                    className={`package_type__centered_text package_type__row vas-row package_type__animate_float `}
                    style={styling}
                  >
                    <p className={`vas package_type__white_text `}>
                      {" "}
                      {t.topSelling}
                    </p>
                  </div>
                </div>
              );
            });
          })}
    </div>
  );
};

export default PackageBestSelling;
